module.exports = __webpack_public_path__ + "static/media/ourServices.9c7c38d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/ourServices.jpg
// module id = 793
// module chunks = 5